import React from 'react';

export function Logo() {

    return (
        <svg className="logo-svg" xmlns="http://www.w3.org/2000/svg" width="53" height="34" viewBox="0 0 53 34">
            <g fill="none" fillRule="evenodd">
                <g fill="#3ECE7F">
                    <g>
                        <path d="M15.16 0c1.062 0 2.045.562 2.584 1.477L21 7h14v9h-9v9h9v9H2c-1.105 0-2-.895-2-2V3c0-1.657 1.343-3 3-3h12.16zM53 25v9h-9v-9h9zm-9-9v9h-9v-9h9z" transform="translate(-250 -52) translate(250 52)" />
                    </g>
                </g>
            </g>
        </svg>
    )

}

export function UploadArrow() {

    return (
        <svg className="upload-file-icon" xmlns="http://www.w3.org/2000/svg" width="67" height="51" viewBox="0 0 67 51">
            <g fill="none" fillRule="evenodd">
                <g fill="#10D261">
                    <g>
                        <g>
                            <g>
                                <path d="M34 0L67 33 1 33z" transform="translate(-927 -405) translate(850 338) translate(36 67) translate(40.01)" />
                                <path d="M20 30H49V51H20z" transform="translate(-927 -405) translate(850 338) translate(36 67) translate(40.01)" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )

}

export function UploadValidation() {

    return (
        <svg className="upload-file-icon" width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
            <g id="tick" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <circle id="Oval" fill="#10D261" cx="25" cy="25" r="25"></circle>
                <g id="Group" transform="translate(26.000000, 22.000000) rotate(45.000000) translate(-26.000000, -22.000000) translate(19.000000, 11.000000)" fill="#FFFFFF">
                    <rect id="Rectangle" x="0" y="19" width="14" height="3"></rect>
                    <rect id="Rectangle" x="11" y="0" width="3" height="22"></rect>
                </g>
            </g>
        </svg>
    )

}

export function UploadDropdown() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35">
            <g fill="none" fillRule="evenodd">
                <g>
                    <g transform="translate(-1147 -963) translate(1147 963)">
                        <rect width="29" height="29" x="3" y="3" fill="#1DBDEF" rx="5" />
                        <path fill="#FFF" stroke="#FFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 12L21 12 20.868 19z" transform="rotate(135 17.5 15.5)" />
                    </g>
                </g>
            </g>
        </svg>
    )
}